/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Avallon API
 * OpenAPI spec version: 1.0.0
 */
import type {
  ListVoiceAgentsParams,
  CreateVoiceAgentBody,
  UpdateVoiceAgentBody,
  ListVoiceAgentVersionsParams,
  PromoteVoiceAgentVersionBody,
  GetVoiceAgentPromptParams,
  UpdateVoiceAgentPromptBody,
  UpdateVoiceAgentModelsBody,
  UpdateCallControlsBody,
  ScheduleJobBody,
  ListJobsParams,
  ListApiKeysParams,
  CreateApiKeyBody,
  UpdateApiKeyBody,
  CreateArtifactBody,
  ListArtifactsParams,
  GetArtifactMetadataKeysParams,
  GetArtifactStatusSummaryParams,
  GetArtifactUploadUrlBody,
  UpdateArtifactMetadataBody,
  SignUpBody,
  SignInBody,
  RequestPasswordResetBody,
  ResetPasswordBody,
  RefreshTokenBody,
  GetOAuthUrlParams,
  GetSessionTokenBody,
  PartnerLaunchParams,
  ListCallsParams,
  GetCallParams,
  GetCallAnalyticsParams,
  GetAnalyticsTimeSeriesParams,
  CreateFeedbackRequest,
  ListCallFeedbackParams,
  CheckInboxAvailabilityParams,
  CreateInboxBody,
  ListInboxesParams,
  UpdateInboxBody,
  ListEmailsParams,
  ListEmailThreadsParams,
  ReplyToEmailBody,
  SendEmailBody,
  ListExtractorJobsParams,
  CreateExtractorJobBody,
  ListWorkerRunsParams,
  CreateWorkerRunBody,
  ListWorkerRunMessagesParams,
  CreateWorkerEvalFromRunBody,
  CreateExtractorBody,
  ListExtractorsParams,
  UpdateExtractorBody,
  CreateWorkerBody,
  ListWorkersParams,
  UpdateWorkerBody,
  GetWorkerPromptParams,
  UpdateWorkerPromptBody,
  UpdateWorkerMcpsBody,
  ListWorkerVersionsParams,
  PromoteWorkerVersionBody,
  CreateWorkerWebhookBody,
  ListWorkerWebhooksParams,
  ListCasesParams,
  CreateCaseBody,
  SearchCasesParams,
  GetCaseParams,
  AddCaseLinksParams,
  AddCaseLinksBody,
  ListCaseLinksParams,
  RemoveCaseLinkParams,
  CreateChatAgentBody,
  ListChatAgentsParams,
  UpdateChatAgentRequest,
  UpdateChatAgentPromptBody,
  CreateChatBody,
  PostChatMessageBody,
  ListChatsParams,
  ListChatMessagesParams,
  ListExtractsParams,
  InviteTeamMemberBody,
  UpdateMemberRoleBody,
  CreateSecretBody,
  ListSecretsParams,
  UpdateSecretBody,
  CreateScheduleBody,
  ListSchedulesParams,
  UpdateScheduleBody,
  ListDispatchesParams,
  ListNotificationsParams,
  CreateInformationRequestBody,
  ListInformationRequestsParams,
  ResolveInformationRequestBody,
  CreateToolBody,
  ListToolsParams,
  UpdateToolBody,
  ExecuteCodeBody,
  ListToolVersionsParams,
  PromoteToolVersionBody,
  WorkerListToolsParams,
  WorkerExecuteToolBody,
  NotifyAdminBody,
  UploadFileBody,
  CreateAgentWebhookBody,
  ListAgentWebhooksParams,
  CreateInboxWebhookBody,
  ListInboxWebhooksParams,
  CreateExtractorWebhookBody,
  ListWebhooksParams,
  CreateNotificationWebhookBody,
  ListNotificationWebhooksParams,
  UpdateWebhookBody,
  ListWebhookDeliveriesParams,
  TestWebhookBody
} from './http-schemas';

import {
  listVoiceAgents,
  createVoiceAgent,
  getVoiceAgent,
  updateVoiceAgent,
  deleteVoiceAgent,
  listVoiceAgentVersions,
  getVoiceAgentVersion,
  promoteVoiceAgentVersion,
  getVoiceAgentVersionChangeSummary,
  getVoiceAgentPlaceholders,
  getVoiceAgentPrompt,
  updateVoiceAgentPrompt,
  updateVoiceAgentModels,
  updateCallControls,
  scheduleJob,
  listJobs,
  cancelJob,
  listApiKeys,
  createApiKey,
  revokeApiKey,
  updateApiKey,
  createArtifact,
  listArtifacts,
  getArtifact,
  deleteArtifact,
  getArtifactMetadataKeys,
  getArtifactStatusSummary,
  getArtifactUploadUrl,
  updateArtifactMetadata,
  signUp,
  signIn,
  requestPasswordReset,
  resetPassword,
  refreshToken,
  getOAuthUrl,
  getSessionToken,
  getPartnerJwks,
  partnerLaunch,
  listCalls,
  getCall,
  getCallEvaluation,
  getCallAnalytics,
  getAnalyticsTimeSeries,
  createCallFeedback,
  listCallFeedback,
  deleteCallFeedback,
  checkInboxAvailability,
  createInbox,
  listInboxes,
  updateInbox,
  deleteInbox,
  getEmail,
  deleteEmail,
  listEmails,
  listEmailThreads,
  replyToEmail,
  sendEmail,
  listExtractorJobs,
  createExtractorJob,
  getExtractorJob,
  listWorkerRuns,
  createWorkerRun,
  getWorkerRun,
  listWorkerRunMessages,
  cancelWorkerRun,
  createWorkerEvalFromRun,
  runEval,
  getEvalRun,
  createExtractor,
  listExtractors,
  getExtractor,
  updateExtractor,
  deleteExtractor,
  createWorker,
  listWorkers,
  getWorker,
  deleteWorker,
  updateWorker,
  getWorkerPrompt,
  updateWorkerPrompt,
  listWorkerModels,
  updateWorkerMcps,
  listWorkerVersions,
  getWorkerVersion,
  promoteWorkerVersion,
  getWorkerVersionChangeSummary,
  createWorkerWebhook,
  listWorkerWebhooks,
  listCases,
  createCase,
  searchCases,
  getCase,
  addCaseLinks,
  listCaseLinks,
  removeCaseLink,
  createChatAgent,
  listChatAgents,
  getChatAgent,
  updateChatAgent,
  deleteChatAgent,
  getChatAgentPrompt,
  updateChatAgentPrompt,
  createChat,
  getChat,
  getPublicChatAgent,
  postChatMessage,
  listChats,
  listChatMessages,
  getExtract,
  getExtractCitations,
  listExtracts,
  getProfile,
  listTeamMembers,
  inviteTeamMember,
  listTeamInvitations,
  revokeTeamInvitation,
  resendTeamInvitation,
  updateMemberRole,
  removeMember,
  createSecret,
  listSecrets,
  getSecret,
  updateSecret,
  deleteSecret,
  createSchedule,
  listSchedules,
  getSchedule,
  updateSchedule,
  deleteSchedule,
  listDispatches,
  listNotifications,
  createInformationRequest,
  listInformationRequests,
  getInformationRequest,
  resolveInformationRequest,
  createTool,
  listTools,
  deleteTool,
  getTool,
  updateTool,
  executeCode,
  listToolVersions,
  getToolVersion,
  promoteToolVersion,
  getToolVersionChangeSummary,
  workerListTools,
  workerGetTool,
  workerExecuteTool,
  notifyAdmin,
  uploadFile,
  createAgentWebhook,
  listAgentWebhooks,
  createInboxWebhook,
  listInboxWebhooks,
  createExtractorWebhook,
  listWebhooks,
  createNotificationWebhook,
  listNotificationWebhooks,
  deleteWebhook,
  getWebhook,
  updateWebhook,
  listWebhookDeliveries,
  testWebhook
} from './http-client';

/**
 * List all voice agents for your tenant.
 *
 * **Filtering:**
 *
 * Filter voice agents by name using the `agent_name` query parameter (exact match).
 *
 * **Response:**
 *
 * Returns an array of all voice agents with their configurations and a total count.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents`
 * @summary List voice agents
 */

export type listVoiceAgentsArgs = {
  queryParams: ListVoiceAgentsParams;
}

export const listVoiceAgentsHandler = async (args: listVoiceAgentsArgs, options?: RequestInit) => {
  const res = await listVoiceAgents(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new voice agent with the specified configuration.
 *
 * **Required fields:**
 *
 * All fields in the request body are required except `phone_number_id` and `transfer_phone_number`.
 *
 * **Response:**
 *
 * Returns the created voice agent with its ID and configuration.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents`
 * @summary Create voice agent
 */

export type createVoiceAgentArgs = {
  bodyParams?: CreateVoiceAgentBody;
}

export const createVoiceAgentHandler = async (args: createVoiceAgentArgs, options?: RequestInit) => {
  const res = await createVoiceAgent(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single voice agent by its ID.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/{id}`
 * @summary Get voice agent
 */

export type getVoiceAgentArgs = {
  pathParams: {
    voiceAgentId: string
  };
}

export const getVoiceAgentHandler = async (args: getVoiceAgentArgs, options?: RequestInit) => {
  const res = await getVoiceAgent(args.pathParams.voiceAgentId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update a voice agent's name, call processor, or call behaviour settings.
 *
 * To change the processor assignment, `call_processor_id` and `call_processor_type` must be provided together. Set `call_processor_id` to `null` to detach (`call_processor_type` is still required).
 *
 * Set `voice_mail_detection` to `true` to have the agent listen for a voicemail beep tone. Detection only runs on `OUTBOUND` agents; enabling it on an `INBOUND` agent is stored but has no effect.
 *
 * Set `noise_cancellation` to choose the noise cancellation mode applied to the caller audio.
 *
 * Set `tool_ids` to replace the agent's attached tool set. This is the supported way to manage tool attachments; the dedicated add and remove endpoints are deprecated.
 *
 * Config changes create a new voice agent config version. The live and test releases keep pointing at their current versions until the new version is promoted.
 * @summary Update voice agent
 */

export type updateVoiceAgentArgs = {
  pathParams: {
    voiceAgentId: string
  };
  bodyParams?: UpdateVoiceAgentBody;
}

export const updateVoiceAgentHandler = async (args: updateVoiceAgentArgs, options?: RequestInit) => {
  const res = await updateVoiceAgent(args.pathParams.voiceAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Delete a voice agent. The agent is hidden from all reads; its call and job history is preserved.
 * @summary Delete voice agent
 */

export type deleteVoiceAgentArgs = {
  pathParams: {
    voiceAgentId: string
  };
}

export const deleteVoiceAgentHandler = async (args: deleteVoiceAgentArgs, options?: RequestInit) => {
  const res = await deleteVoiceAgent(args.pathParams.voiceAgentId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all config versions for a voice agent, ordered by version (newest first by default).
 * @summary List voice agent versions
 */

export type listVoiceAgentVersionsArgs = {
  pathParams: {
    voiceAgentId: string
  };
  queryParams: ListVoiceAgentVersionsParams;
}

export const listVoiceAgentVersionsHandler = async (args: listVoiceAgentVersionsArgs, options?: RequestInit) => {
  const res = await listVoiceAgentVersions(args.pathParams.voiceAgentId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single voice agent config version, including the agent's identity, the config snapshot at that version, and version-specific metadata.
 * @summary Get voice agent version
 */

export type getVoiceAgentVersionArgs = {
  pathParams: {
    voiceAgentId: string,
    version: number
  };
}

export const getVoiceAgentVersionHandler = async (args: getVoiceAgentVersionArgs, options?: RequestInit) => {
  const res = await getVoiceAgentVersion(args.pathParams.voiceAgentId, args.pathParams.version, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Select a voice agent configuration version for the live or test environment.
 * @summary Promote voice agent version
 */

export type promoteVoiceAgentVersionArgs = {
  pathParams: {
    voiceAgentId: string,
    version: number
  };
  bodyParams?: PromoteVoiceAgentVersionBody;
}

export const promoteVoiceAgentVersionHandler = async (args: promoteVoiceAgentVersionArgs, options?: RequestInit) => {
  const res = await promoteVoiceAgentVersion(args.pathParams.voiceAgentId, args.pathParams.version, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.
 * @summary Get voice agent version change summary
 */

export type getVoiceAgentVersionChangeSummaryArgs = {
  pathParams: {
    voiceAgentId: string,
    version: number
  };
}

export const getVoiceAgentVersionChangeSummaryHandler = async (args: getVoiceAgentVersionChangeSummaryArgs, options?: RequestInit) => {
  const res = await getVoiceAgentVersionChangeSummary(args.pathParams.voiceAgentId, args.pathParams.version, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve the available placeholder variables defined in a voice agent's prompt.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/{id}/prompt`
 * @summary Get voice agent placeholders
 */

export type getVoiceAgentPlaceholdersArgs = {
  pathParams: {
    voiceAgentId: string
  };
}

export const getVoiceAgentPlaceholdersHandler = async (args: getVoiceAgentPlaceholdersArgs, options?: RequestInit) => {
  const res = await getVoiceAgentPlaceholders(args.pathParams.voiceAgentId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve the prompt for a voice agent. Pass `version` to fetch the prompt snapshot at a specific config version; omit it to fetch the current prompt. Internal use only.
 * @summary Get voice agent prompt
 */

export type getVoiceAgentPromptArgs = {
  pathParams: {
    voiceAgentId: string
  };
  queryParams: GetVoiceAgentPromptParams;
}

export const getVoiceAgentPromptHandler = async (args: getVoiceAgentPromptArgs, options?: RequestInit) => {
  const res = await getVoiceAgentPrompt(args.pathParams.voiceAgentId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update the prompt for a voice agent. Internal use only.
 * @summary Update voice agent prompt
 */

export type updateVoiceAgentPromptArgs = {
  pathParams: {
    voiceAgentId: string
  };
  bodyParams?: UpdateVoiceAgentPromptBody;
}

export const updateVoiceAgentPromptHandler = async (args: updateVoiceAgentPromptArgs, options?: RequestInit) => {
  const res = await updateVoiceAgentPrompt(args.pathParams.voiceAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update the LLM, TTS, and STT model configuration for a voice agent.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `PATCH /v1/agents/{id}/models`
 * @summary Update voice agent models
 */

export type updateVoiceAgentModelsArgs = {
  pathParams: {
    voiceAgentId: string
  };
  bodyParams?: UpdateVoiceAgentModelsBody;
}

export const updateVoiceAgentModelsHandler = async (args: updateVoiceAgentModelsArgs, options?: RequestInit) => {
  const res = await updateVoiceAgentModels(args.pathParams.voiceAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update call control settings for a voice agent.
 *
 * Configure whether the voice agent supports dial pad input, can end calls, and set a transfer phone number.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `PUT /v1/agents/{id}/call-controls`
 * @summary Update voice agent call controls
 */

export type updateCallControlsArgs = {
  pathParams: {
    voiceAgentId: string
  };
  bodyParams?: UpdateCallControlsBody;
}

export const updateCallControlsHandler = async (args: updateCallControlsArgs, options?: RequestInit) => {
  const res = await updateCallControls(args.pathParams.voiceAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Schedule a new outbound call job for a voice agent.
 *
 * The job can be scheduled for a future time or triggered immediately with `trigger_immediately: true`.
 *
 * **Scheduling:**
 *
 * When scheduling for a future time, provide `scheduled_at` (ISO 8601) and optionally `schedule_window_minutes` (minimum 10 minutes).
 *
 * **Environment:**
 *
 * `environment` selects which promoted agent configuration and phone binding the call dispatches against (`live` or `test`). Defaults to `live`. Scheduling fails when the selected environment has no active promotion.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents/{id}/jobs`
 * @summary Schedule an outbound job
 */

export type scheduleJobArgs = {
  pathParams: {
    voiceAgentId: string
  };
  bodyParams?: ScheduleJobBody;
}

export const scheduleJobHandler = async (args: scheduleJobArgs, options?: RequestInit) => {
  const res = await scheduleJob(args.pathParams.voiceAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all outbound jobs with pagination and filtering.
 *
 * **Filtering:**
 *
 * - Filter by agent ID, status, or scheduled time range.
 * - Multiple statuses can be comma-separated (e.g. `status=pending,queued`).
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/jobs`
 * @summary List outbound jobs
 */

export type listJobsArgs = {
  queryParams: ListJobsParams;
}

export const listJobsHandler = async (args: listJobsArgs, options?: RequestInit) => {
  const res = await listJobs(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Cancel a pending or queued outbound job. Jobs that are already in progress or completed cannot be canceled.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents/jobs/{id}/cancel`
 * @summary Cancel an outbound job
 */

export type cancelJobArgs = {
  pathParams: {
    jobId: string
  };
}

export const cancelJobHandler = async (args: cancelJobArgs, options?: RequestInit) => {
  const res = await cancelJob(args.pathParams.jobId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all API keys for your tenant.
 *
 * By default, revoked keys are excluded. Set `include_revoked=true` to include them.
 *
 * **Note:** The full API key value is never returned — only the key prefix is shown.
 * @summary List API keys
 */

export type listApiKeysArgs = {
  queryParams: ListApiKeysParams;
}

export const listApiKeysHandler = async (args: listApiKeysArgs, options?: RequestInit) => {
  const res = await listApiKeys(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new API key for authenticating with the Avallon API.
 *
 * **Important:** The full API key is only returned once in the response. Store it securely — it cannot be retrieved again.
 *
 * Keys are scoped to an environment (`test` or `live`) and optionally accept an expiration date.
 * @summary Create an API key
 */

export type createApiKeyArgs = {
  bodyParams?: CreateApiKeyBody;
}

export const createApiKeyHandler = async (args: createApiKeyArgs, options?: RequestInit) => {
  const res = await createApiKey(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Revoke an existing API key. Once revoked, the key can no longer be used for authentication.
 *
 * This operation is irreversible — revoked keys cannot be re-enabled. Create a new key if needed.
 *
 * Returns 409 if the key is already revoked, 404 if the key does not exist.
 * @summary Revoke an API key
 */

export type revokeApiKeyArgs = {
  pathParams: {
    id: string
  };
}

export const revokeApiKeyHandler = async (args: revokeApiKeyArgs, options?: RequestInit) => {
  const res = await revokeApiKey(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update mutable fields of an API key. Currently only `role` can be updated.
 *
 * The caller's role caps the maximum role they can grant — an `admin` cannot promote a key to `avallon_admin`.
 * @summary Update API key
 */

export type updateApiKeyArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: UpdateApiKeyBody;
}

export const updateApiKeyHandler = async (args: updateApiKeyArgs, options?: RequestInit) => {
  const res = await updateApiKey(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Upload a document as a base64-encoded artifact for processing.
 *
 * **Limits:**
 *
 * Maximum file size is approximately 6.75MB (base64 encoded). The API Gateway has a 10MB request limit.
 *
 * **Processing options:**
 *
 * - `file_password`: Password for encrypted PDFs
 * - `file_splitting_enabled`: Split multi-page PDFs into separate artifacts
 * @summary Create artifact
 */

export type createArtifactArgs = {
  bodyParams?: CreateArtifactBody;
}

export const createArtifactHandler = async (args: createArtifactArgs, options?: RequestInit) => {
  const res = await createArtifact(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all artifacts with pagination, filtering, and sorting.
 *
 * **Case Filtering:**
 *
 * Use `case_id` to return only artifacts linked to a case. This reads the case links
 * created via `POST /v1/cases/{caseId}/links`, and is independent of any
 * `metadata.case_id` an artifact may carry.
 *
 * **Metadata Filtering:**
 *
 * Use bracket notation to filter by metadata keys:
 * - `metadata[claim_id]=abc-123`
 * - `metadata[source]=email`
 *
 * Multiple metadata filters can be combined (AND logic).
 * @summary List artifacts
 */

export type listArtifactsArgs = {
  queryParams: ListArtifactsParams;
}

export const listArtifactsHandler = async (args: listArtifactsArgs, options?: RequestInit) => {
  const res = await listArtifacts(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single artifact by ID, including its metadata, file URL, extracted content, and chunk-annotated content.
 *
 * The response always includes `content_with_chunkids_md`: the parsed content annotated with `[chunk_id=...]` markers when the artifact has parsed chunks. Chunk IDs are stable citation anchors — cite them to attribute extracted values to their source location.
 * @summary Get artifact
 */

export type getArtifactArgs = {
  pathParams: {
    id: string
  };
}

export const getArtifactHandler = async (args: getArtifactArgs, options?: RequestInit) => {
  const res = await getArtifact(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Soft-delete an artifact. Soft-deleted artifacts and their chunks no longer appear in any read.
 * @summary Delete artifact
 */

export type deleteArtifactArgs = {
  pathParams: {
    id: string
  };
}

export const deleteArtifactHandler = async (args: deleteArtifactArgs, options?: RequestInit) => {
  const res = await deleteArtifact(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve all unique metadata keys and their values across artifacts. Useful for building filter UIs.
 * @summary Get artifact metadata keys
 */

export type getArtifactMetadataKeysArgs = {
  queryParams: GetArtifactMetadataKeysParams;
}

export const getArtifactMetadataKeysHandler = async (args: getArtifactMetadataKeysArgs, options?: RequestInit) => {
  const res = await getArtifactMetadataKeys(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Count the artifacts in a scope, broken down by processing status.
 *
 * Define the scope with bracket notation (e.g. `scope[email_id]=abc-123`). At least one key is required; multiple keys are combined with AND logic.
 * @summary Get artifact status summary
 */

export type getArtifactStatusSummaryArgs = {
  queryParams: GetArtifactStatusSummaryParams;
}

export const getArtifactStatusSummaryHandler = async (args: getArtifactStatusSummaryArgs, options?: RequestInit) => {
  const res = await getArtifactStatusSummary(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Returns a pre-signed PUT URL. Upload the file directly to `upload_url`, then pass `file_url` as `source_url` to POST /v1/upload-file.
 * @summary Request a pre-signed URL for direct large file upload
 */

export type getArtifactUploadUrlArgs = {
  bodyParams?: GetArtifactUploadUrlBody;
}

export const getArtifactUploadUrlHandler = async (args: getArtifactUploadUrlArgs, options?: RequestInit) => {
  const res = await getArtifactUploadUrl(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Merge-update metadata on an existing artifact. Provided keys are added or overwritten; other existing keys are preserved.
 * @summary Update artifact metadata
 */

export type updateArtifactMetadataArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: UpdateArtifactMetadataBody;
}

export const updateArtifactMetadataHandler = async (args: updateArtifactMetadataArgs, options?: RequestInit) => {
  const res = await updateArtifactMetadata(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new user account with email and password. When the response includes a pending_authentication_token, the account requires email verification: complete it via sign-in (type: email_otp) with the emailed one-time password and this token.
 * @summary Sign up
 */

export type signUpArgs = {
  bodyParams?: SignUpBody;
}

export const signUpHandler = async (args: signUpArgs, options?: RequestInit) => {
  const res = await signUp(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Authenticate using one of the supported methods:
 *
 * - **Password:** Email and password credentials. If the password is correct but the email is not verified yet, responds 403 with `data.pending_authentication_token` and a fresh verification code is emailed; complete verification via **Email OTP**. Each password attempt invalidates earlier codes and tokens, so always use the most recent pair — repeating the password sign-in is also how a new code is requested.
 * - **OAuth:** Authorization code from OAuth flow (social or enterprise SSO). Pass the `provider` the flow was started with so the code is exchanged against the system that issued it. `verifier` is only required when the flow was started with a `code_challenge` — see **Get OAuth sign-in URL**.
 * - **Email OTP:** One-time password sent to email. Include the `pending_authentication_token` from sign-up, or from the 403 returned by an unverified user's password sign-in, when completing email verification.
 * @summary Sign in
 */

export type signInArgs = {
  bodyParams?: SignInBody;
}

export const signInHandler = async (args: signInArgs, options?: RequestInit) => {
  const res = await signIn(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Start password recovery for an email/password account. When the email belongs to an account, a reset link is emailed to it. The response is 200 regardless, and does not reveal whether an account exists.
 * @summary Request password reset
 */

export type requestPasswordResetArgs = {
  bodyParams?: RequestPasswordResetBody;
}

export const requestPasswordResetHandler = async (args: requestPasswordResetArgs, options?: RequestInit) => {
  const res = await requestPasswordReset(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Complete password recovery with the token from the emailed reset link and set a new password. Completing the reset also verifies the account's email address. Afterwards, sign in with the new password.
 * @summary Reset password
 */

export type resetPasswordArgs = {
  bodyParams?: ResetPasswordBody;
}

export const resetPasswordHandler = async (args: resetPasswordArgs, options?: RequestInit) => {
  const res = await resetPassword(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Exchange a valid access token and refresh token pair for new tokens.
 * @summary Refresh authentication token
 */

export type refreshTokenArgs = {
  bodyParams?: RefreshTokenBody;
}

export const refreshTokenHandler = async (args: refreshTokenArgs, options?: RequestInit) => {
  const res = await refreshToken(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Generate an OAuth authorization URL for a given provider.
 *
 * PKCE is optional. To use it, generate a random verifier, derive `code_challenge` from it, and pass both `code_challenge` and the matching `code_challenge_method` — then send the verifier to **Sign in** when exchanging the code. Omit both to run the flow without PKCE and exchange the code on its own.
 *
 * For enterprise SSO, pass `provider=sso` together with the user's `email`; the email domain selects the SSO organization. Responds 404 when no SSO organization is configured for the domain.
 * @summary Get OAuth sign-in URL
 */

export type getOAuthUrlArgs = {
  queryParams: GetOAuthUrlParams;
}

export const getOAuthUrlHandler = async (args: getOAuthUrlArgs, options?: RequestInit) => {
  const res = await getOAuthUrl(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Exchange an identity token for a tenant-scoped Core Plane access token.
 *
 * - If `tenant_id` is provided, validates the user is a member of that tenant and returns 404 if they are not.
 * - If `tenant_id` is omitted, selects the tenant of the identity token's organization, falling back to the user's default (oldest) tenant.
 * - Call this endpoint again with a different `tenant_id` to switch tenants.
 * @summary Create or switch tenant session
 */

export type getSessionTokenArgs = {
  bodyParams?: GetSessionTokenBody;
}

export const getSessionTokenHandler = async (args: getSessionTokenArgs, options?: RequestInit) => {
  const res = await getSessionToken(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Returns the JSON Web Key Set (RFC 7517) of a partner's public signing keys, used to verify partner-issued launch tokens.
 * @summary Get partner JWKS
 */

export type getPartnerJwksArgs = {
  pathParams: {
    partner: string
  };
}

export const getPartnerJwksHandler = async (args: getPartnerJwksArgs, options?: RequestInit) => {
  const res = await getPartnerJwks(args.pathParams.partner, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Verifies a partner-signed launch token, mints an Avallon session, and redirects (302) the user into the app's handoff route, carrying the session token in the URL fragment (no cookie).
 * @summary Partner launch (SSO)
 */

export type partnerLaunchArgs = {
  queryParams: PartnerLaunchParams;
}

export const partnerLaunchHandler = async (args: partnerLaunchArgs, options?: RequestInit) => {
  const res = await partnerLaunch(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all calls, with pagination, filtering, and sorting.
 *
 * **Filtering:**
 *
 * Filter by agent, direction, status, time range, phone number, and more. Phone number filter supports both exact E.164 matches and partial search.
 *
 * **Case Filtering:**
 *
 * Use `case_id` to return only calls linked to a case. This reads the case links created
 * via `POST /v1/cases/{caseId}/links`, and is independent of any `metadata.case_id` a
 * call may carry.
 *
 * **Metadata Filtering:**
 *
 * Use bracket notation to filter by metadata keys:
 * - `metadata[claim_id]=abc-123`
 * - `metadata[source]=worker`
 *
 * Multiple metadata filters can be combined (AND logic).
 * @summary List calls
 */

export type listCallsArgs = {
  queryParams: ListCallsParams;
}

export const listCallsHandler = async (args: listCallsArgs, options?: RequestInit) => {
  const res = await listCalls(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve detailed information about a specific call.
 *
 * Set `include_messages=true` to include the full message transcript.
 * @summary Get call
 */

export type getCallArgs = {
  pathParams: {
    id: string
  };
  queryParams: GetCallParams;
}

export const getCallHandler = async (args: getCallArgs, options?: RequestInit) => {
  const res = await getCall(args.pathParams.id, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve the evaluation results for a specific call, including overall score, pass status, and per-metric breakdowns.
 * @summary Get call evaluation
 */

export type getCallEvaluationArgs = {
  pathParams: {
    id: string
  };
}

export const getCallEvaluationHandler = async (args: getCallEvaluationArgs, options?: RequestInit) => {
  const res = await getCallEvaluation(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve aggregated call analytics for a time range.
 *
 * Includes summary statistics, call volume over time, evaluation scores, score and duration distributions, and per-metric performance.
 * @summary Get call analytics
 */

export type getCallAnalyticsArgs = {
  queryParams: GetCallAnalyticsParams;
}

export const getCallAnalyticsHandler = async (args: getCallAnalyticsArgs, options?: RequestInit) => {
  const res = await getCallAnalytics(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a tenant-scoped time series for a single processing-volume metric.
 *
 * Pick a `metric` (worker runs, documents, or pages), a date range, a bucket `granularity` (day/week/month), and optionally a `group_by` dimension (e.g. worker runs grouped by worker). The series is sparse (only buckets with data) over the half-open window `[from, to)`.
 *
 * `data` is an array of per-metric results; today it always contains exactly one entry (the requested metric).
 * @summary Get analytics time series
 */

export type getAnalyticsTimeSeriesArgs = {
  queryParams: GetAnalyticsTimeSeriesParams;
}

export const getAnalyticsTimeSeriesHandler = async (args: getAnalyticsTimeSeriesArgs, options?: RequestInit) => {
  const res = await getAnalyticsTimeSeries(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create feedback for a specific message in a call. Requires user (JWT) authentication; the author is derived from the authenticated user's profile and API-key callers are rejected.
 * @summary Create feedback on a call message
 */

export type createCallFeedbackArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: CreateFeedbackRequest;
}

export const createCallFeedbackHandler = async (args: createCallFeedbackArgs, options?: RequestInit) => {
  const res = await createCallFeedback(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all feedback for a call. Paginated.
 * @summary List feedback for a call
 */

export type listCallFeedbackArgs = {
  pathParams: {
    id: string
  };
  queryParams: ListCallFeedbackParams;
}

export const listCallFeedbackHandler = async (args: listCallFeedbackArgs, options?: RequestInit) => {
  const res = await listCallFeedback(args.pathParams.id, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Delete a single feedback entry.
 * @summary Delete feedback
 */

export type deleteCallFeedbackArgs = {
  pathParams: {
    id: string,
    feedbackId: string
  };
}

export const deleteCallFeedbackHandler = async (args: deleteCallFeedbackArgs, options?: RequestInit) => {
  const res = await deleteCallFeedback(args.pathParams.id, args.pathParams.feedbackId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Check whether a given email username is available for creating a new inbox.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/email-agents/availability`
 * @summary Check email username availability
 */

export type checkInboxAvailabilityArgs = {
  queryParams: CheckInboxAvailabilityParams;
}

export const checkInboxAvailabilityHandler = async (args: checkInboxAvailabilityArgs, options?: RequestInit) => {
  const res = await checkInboxAvailability(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new inbox linked to a processor (extractor or worker).
 *
 * The inbox will receive emails at the assigned address and automatically process attachments using the specified processor.
 *
 * Either `processor_id` or the deprecated `extractor_id` must be provided. When using `extractor_id`, the processor type defaults to `extractor`.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/email-agents`
 * @summary Create inbox
 */

export type createInboxArgs = {
  bodyParams?: CreateInboxBody;
}

export const createInboxHandler = async (args: createInboxArgs, options?: RequestInit) => {
  const res = await createInbox(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all inboxes with pagination and sorting.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/email-agents`
 * @summary List inboxes
 */

export type listInboxesArgs = {
  queryParams: ListInboxesParams;
}

export const listInboxesHandler = async (args: listInboxesArgs, options?: RequestInit) => {
  const res = await listInboxes(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update an inbox's configuration.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `PATCH /v1/email-agents/{id}`
 * @summary Update inbox
 */

export type updateInboxArgs = {
  pathParams: {
    inboxId: string
  };
  bodyParams?: UpdateInboxBody;
}

export const updateInboxHandler = async (args: updateInboxArgs, options?: RequestInit) => {
  const res = await updateInbox(args.pathParams.inboxId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Delete an inbox. The inbox stops routing new mail; existing email history is preserved.
 * @summary Delete inbox
 */

export type deleteInboxArgs = {
  pathParams: {
    inboxId: string
  };
}

export const deleteInboxHandler = async (args: deleteInboxArgs, options?: RequestInit) => {
  const res = await deleteInbox(args.pathParams.inboxId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve detailed information about a specific email, including full body content.
 * @summary Get email
 */

export type getEmailArgs = {
  pathParams: {
    emailId: string
  };
}

export const getEmailHandler = async (args: getEmailArgs, options?: RequestInit) => {
  const res = await getEmail(args.pathParams.emailId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Soft-delete an email. The message is hidden from all reads (get, list, and thread aggregation) but its content is retained until a separate hard purge.
 * @summary Delete email
 */

export type deleteEmailArgs = {
  pathParams: {
    emailId: string
  };
}

export const deleteEmailHandler = async (args: deleteEmailArgs, options?: RequestInit) => {
  const res = await deleteEmail(args.pathParams.emailId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all emails with pagination and filtering.
 *
 * **Filtering:**
 *
 * Filter by email agent, sender, recipient, content search, or case.
 * @summary List emails
 */

export type listEmailsArgs = {
  queryParams: ListEmailsParams;
}

export const listEmailsHandler = async (args: listEmailsArgs, options?: RequestInit) => {
  const res = await listEmails(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List email threads with pagination. Each thread includes the subject of the first email, the sender of the first email, and the date of the last email.
 *
 * **Filtering:**
 *
 * Filter by inbox or environment. Without an `environment` filter, live and test threads are returned together.
 * @summary List email threads
 */

export type listEmailThreadsArgs = {
  queryParams: ListEmailThreadsParams;
}

export const listEmailThreadsHandler = async (args: listEmailThreadsArgs, options?: RequestInit) => {
  const res = await listEmailThreads(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Reply to an existing email thread via Nylas. The reply is sent to the original sender by default.
 *
 * Optionally include additional recipients via `to` (merged with the original sender), `cc`, and `bcc` arrays.
 *
 * The `body` is HTML by default. Set `is_html` to `false` to provide plain text instead; it is converted to HTML before sending.
 * @summary Reply to email
 */

export type replyToEmailArgs = {
  pathParams: {
    emailId: string
  };
  bodyParams?: ReplyToEmailBody;
}

export const replyToEmailHandler = async (args: replyToEmailArgs, options?: RequestInit) => {
  const res = await replyToEmail(args.pathParams.emailId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Send a new email through an inbox. The provider-assigned thread id is returned and persisted on the stored email row, so subsequent inbound replies on that thread are linked to this send.
 *
 * The `body` is HTML by default. Set `is_html` to `false` to provide plain text instead; it is converted to HTML before sending.
 * @summary Send email
 */

export type sendEmailArgs = {
  bodyParams?: SendEmailBody;
}

export const sendEmailHandler = async (args: sendEmailArgs, options?: RequestInit) => {
  const res = await sendEmail(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all extraction jobs with pagination, filtering, and sorting.
 *
 * **Scope Filtering:**
 *
 * Use bracket notation to filter by scope keys:
 * - `scope[call_id]=abc-123`
 * - `scope[email_id]=xyz-456`
 * - `scope[case_id]=case-789`
 *
 * Multiple scope filters can be combined (AND logic).
 * @summary List extractor jobs
 */

export type listExtractorJobsArgs = {
  queryParams: ListExtractorJobsParams;
}

export const listExtractorJobsHandler = async (args: listExtractorJobsArgs, options?: RequestInit) => {
  const res = await listExtractorJobs(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new extraction job for the specified extractor.
 *
 * Provide a non-empty `scope` object to define what the extractor should process (e.g. `{ "claim_id": "abc-123" }`).
 * @summary Create extractor job
 */

export type createExtractorJobArgs = {
  bodyParams?: CreateExtractorJobBody;
}

export const createExtractorJobHandler = async (args: createExtractorJobArgs, options?: RequestInit) => {
  const res = await createExtractorJob(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve detailed information about a specific extractor job, including its status, timing, and result.
 * @summary Get extractor job
 */

export type getExtractorJobArgs = {
  pathParams: {
    id: string
  };
}

export const getExtractorJobHandler = async (args: getExtractorJobArgs, options?: RequestInit) => {
  const res = await getExtractorJob(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all worker runs with pagination, filtering, and sorting.
 *
 * **Scope Filtering:**
 *
 * Use bracket notation to filter by scope keys:
 * - `scope[call_id]=abc-123`
 * - `scope[email_id]=xyz-456`
 *
 * Multiple scope filters can be combined (AND logic).
 * @summary List worker runs
 */

export type listWorkerRunsArgs = {
  queryParams: ListWorkerRunsParams;
}

export const listWorkerRunsHandler = async (args: listWorkerRunsArgs, options?: RequestInit) => {
  const res = await listWorkerRuns(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new worker run for the specified worker.
 *
 * Provide a `scope` object with at least one key to define which artifacts the worker should process (e.g. `{ "claim_id": "abc-123" }`). The run stays `pending` until those artifacts are ready.
 *
 * Pass `null` to run the worker without any artifacts — the run is queued immediately. An empty object is rejected.
 * @summary Create worker run
 */

export type createWorkerRunArgs = {
  bodyParams?: CreateWorkerRunBody;
}

export const createWorkerRunHandler = async (args: createWorkerRunArgs, options?: RequestInit) => {
  const res = await createWorkerRun(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve detailed information about a specific worker run, including its status, timing, and errors.
 * @summary Get worker run
 */

export type getWorkerRunArgs = {
  pathParams: {
    workerRunId: string
  };
}

export const getWorkerRunHandler = async (args: getWorkerRunArgs, options?: RequestInit) => {
  const res = await getWorkerRun(args.pathParams.workerRunId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve messages emitted during a worker run, ordered by emission time. Supports cursor-style pagination via `after` and `count`.
 * @summary List worker run messages
 */

export type listWorkerRunMessagesArgs = {
  pathParams: {
    workerRunId: string
  };
  queryParams: ListWorkerRunMessagesParams;
}

export const listWorkerRunMessagesHandler = async (args: listWorkerRunMessagesArgs, options?: RequestInit) => {
  const res = await listWorkerRunMessages(args.pathParams.workerRunId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Cancel a worker run. For in_progress runs, the underlying E2B sandbox is terminated when possible. Pending and queued runs are simply marked canceled. Runs that are starting are still being handed their context and cannot be interrupted, so they cannot be canceled until they reach in_progress. Runs in terminal states (completed, failed) cannot be canceled. Already-canceled runs are returned without side effects.
 * @summary Cancel a worker run
 */

export type cancelWorkerRunArgs = {
  pathParams: {
    workerRunId: string
  };
}

export const cancelWorkerRunHandler = async (args: cancelWorkerRunArgs, options?: RequestInit) => {
  const res = await cancelWorkerRun(args.pathParams.workerRunId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Snapshot a worker run's trigger and resolved artifacts. Mock responses are returned in call order.
 * @summary Create a worker eval from a run
 */

export type createWorkerEvalFromRunArgs = {
  pathParams: {
    workerRunId: string
  };
  bodyParams?: CreateWorkerEvalFromRunBody;
}

export const createWorkerEvalFromRunHandler = async (args: createWorkerEvalFromRunArgs, options?: RequestInit) => {
  const res = await createWorkerEvalFromRun(args.pathParams.workerRunId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Queue the worker's current test version against the eval's immutable artifact snapshot and mocked tools.
 * @summary Run an eval
 */

export type runEvalArgs = {
  pathParams: {
    evalId: string
  };
}

export const runEvalHandler = async (args: runEvalArgs, options?: RequestInit) => {
  const res = await runEval(args.pathParams.evalId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Get the status and prompt-grader result for an eval run.
 * @summary Get an eval run
 */

export type getEvalRunArgs = {
  pathParams: {
    evalRunId: string
  };
}

export const getEvalRunHandler = async (args: getEvalRunArgs, options?: RequestInit) => {
  const res = await getEvalRun(args.pathParams.evalRunId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new extractor with a name and JSON schema defining the extraction output format.
 * @summary Create extractor
 */

export type createExtractorArgs = {
  bodyParams?: CreateExtractorBody;
}

export const createExtractorHandler = async (args: createExtractorArgs, options?: RequestInit) => {
  const res = await createExtractor(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all extractors with pagination, filtering, and sorting.
 *
 * Filter by name using the `name` query parameter.
 * @summary List extractors
 */

export type listExtractorsArgs = {
  queryParams: ListExtractorsParams;
}

export const listExtractorsHandler = async (args: listExtractorsArgs, options?: RequestInit) => {
  const res = await listExtractors(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single extractor by ID, including its schema and version.
 * @summary Get extractor
 */

export type getExtractorArgs = {
  pathParams: {
    id: string
  };
}

export const getExtractorHandler = async (args: getExtractorArgs, options?: RequestInit) => {
  const res = await getExtractor(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update an extractor's schema. This creates a new version of the extractor.
 * @summary Update extractor
 */

export type updateExtractorArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: UpdateExtractorBody;
}

export const updateExtractorHandler = async (args: updateExtractorArgs, options?: RequestInit) => {
  const res = await updateExtractor(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Soft-delete an extractor and all of its versions. Soft-deleted extractors no longer appear in any read.
 * @summary Delete extractor
 */

export type deleteExtractorArgs = {
  pathParams: {
    id: string
  };
}

export const deleteExtractorHandler = async (args: deleteExtractorArgs, options?: RequestInit) => {
  const res = await deleteExtractor(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new worker with a name and prompt.
 * @summary Create worker
 */

export type createWorkerArgs = {
  bodyParams?: CreateWorkerBody;
}

export const createWorkerHandler = async (args: createWorkerArgs, options?: RequestInit) => {
  const res = await createWorker(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all workers with pagination, filtering, and sorting.
 *
 * Filter by name using the `name` query parameter.
 * @summary List workers
 */

export type listWorkersArgs = {
  queryParams: ListWorkersParams;
}

export const listWorkersHandler = async (args: listWorkersArgs, options?: RequestInit) => {
  const res = await listWorkers(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single worker by ID.
 * @summary Get worker
 */

export type getWorkerArgs = {
  pathParams: {
    workerId: string
  };
}

export const getWorkerHandler = async (args: getWorkerArgs, options?: RequestInit) => {
  const res = await getWorker(args.pathParams.workerId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Delete a worker. The worker is hidden from all reads; its run history is preserved.
 * @summary Delete worker
 */

export type deleteWorkerArgs = {
  pathParams: {
    workerId: string
  };
}

export const deleteWorkerHandler = async (args: deleteWorkerArgs, options?: RequestInit) => {
  const res = await deleteWorker(args.pathParams.workerId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update the configuration of a worker, including the attached tool set.
 * @summary Update worker
 */

export type updateWorkerArgs = {
  pathParams: {
    workerId: string
  };
  bodyParams?: UpdateWorkerBody;
}

export const updateWorkerHandler = async (args: updateWorkerArgs, options?: RequestInit) => {
  const res = await updateWorker(args.pathParams.workerId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve the prompt for a worker. Pass `version` to fetch the prompt snapshot at a specific config version; omit it to fetch the current prompt. Internal use only.
 * @summary Get worker prompt
 */

export type getWorkerPromptArgs = {
  pathParams: {
    workerId: string
  };
  queryParams: GetWorkerPromptParams;
}

export const getWorkerPromptHandler = async (args: getWorkerPromptArgs, options?: RequestInit) => {
  const res = await getWorkerPrompt(args.pathParams.workerId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update the prompt for a worker. Internal use only.
 * @summary Update worker prompt
 */

export type updateWorkerPromptArgs = {
  pathParams: {
    workerId: string
  };
  bodyParams?: UpdateWorkerPromptBody;
}

export const updateWorkerPromptHandler = async (args: updateWorkerPromptArgs, options?: RequestInit) => {
  const res = await updateWorkerPrompt(args.pathParams.workerId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the LLM models that can be assigned to a worker via the `model` field on update.
 * @summary List available worker models
 */

export const listWorkerModelsHandler = async (options?: RequestInit) => {
  const res = await listWorkerModels(options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Replace the set of MCP servers a worker connects to. Pass an empty array to disconnect.
 * @summary Update worker MCP servers
 */

export type updateWorkerMcpsArgs = {
  pathParams: {
    workerId: string
  };
  bodyParams?: UpdateWorkerMcpsBody;
}

export const updateWorkerMcpsHandler = async (args: updateWorkerMcpsArgs, options?: RequestInit) => {
  const res = await updateWorkerMcps(args.pathParams.workerId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all config versions for a worker, ordered by version (newest first by default).
 * @summary List worker versions
 */

export type listWorkerVersionsArgs = {
  pathParams: {
    workerId: string
  };
  queryParams: ListWorkerVersionsParams;
}

export const listWorkerVersionsHandler = async (args: listWorkerVersionsArgs, options?: RequestInit) => {
  const res = await listWorkerVersions(args.pathParams.workerId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single worker config version, including the worker's identity, the config snapshot at that version, and version-specific metadata. The prompt is served separately by the worker prompt endpoint.
 * @summary Get worker version
 */

export type getWorkerVersionArgs = {
  pathParams: {
    workerId: string,
    version: number
  };
}

export const getWorkerVersionHandler = async (args: getWorkerVersionArgs, options?: RequestInit) => {
  const res = await getWorkerVersion(args.pathParams.workerId, args.pathParams.version, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Select a worker configuration version for the live or test environment. This freezes the config snapshot only — the E2B template, attached tools and attached secrets are not versioned and always resolve to their current values.
 * @summary Promote worker version
 */

export type promoteWorkerVersionArgs = {
  pathParams: {
    workerId: string,
    version: number
  };
  bodyParams?: PromoteWorkerVersionBody;
}

export const promoteWorkerVersionHandler = async (args: promoteWorkerVersionArgs, options?: RequestInit) => {
  const res = await promoteWorkerVersion(args.pathParams.workerId, args.pathParams.version, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.
 * @summary Get worker version change summary
 */

export type getWorkerVersionChangeSummaryArgs = {
  pathParams: {
    workerId: string,
    version: number
  };
}

export const getWorkerVersionChangeSummaryHandler = async (args: getWorkerVersionChangeSummaryArgs, options?: RequestInit) => {
  const res = await getWorkerVersionChangeSummary(args.pathParams.workerId, args.pathParams.version, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a webhook that fires when events occur for the specified worker.
 * @summary Create worker webhook
 */

export type createWorkerWebhookArgs = {
  pathParams: {
    workerId: string
  };
  bodyParams?: CreateWorkerWebhookBody;
}

export const createWorkerWebhookHandler = async (args: createWorkerWebhookArgs, options?: RequestInit) => {
  const res = await createWorkerWebhook(args.pathParams.workerId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all webhooks configured for a specific worker.
 * @summary List worker webhooks
 */

export type listWorkerWebhooksArgs = {
  pathParams: {
    workerId: string
  };
  queryParams: ListWorkerWebhooksParams;
}

export const listWorkerWebhooksHandler = async (args: listWorkerWebhooksArgs, options?: RequestInit) => {
  const res = await listWorkerWebhooks(args.pathParams.workerId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all cases for the current tenant, paginated, filterable, and sortable.
 * @summary List cases
 */

export type listCasesArgs = {
  queryParams: ListCasesParams;
}

export const listCasesHandler = async (args: listCasesArgs, options?: RequestInit) => {
  const res = await listCases(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a case with a client-supplied id.
 *
 * Case ids are tenant-scoped opaque keys (e.g. "clm-1", "STD-001") and are normalized server-side (trimmed and lowercased). Creating an id that already exists **in the same environment** returns 409 — the same id can exist once in `live` and once in `test`.
 * @summary Create case
 */

export type createCaseArgs = {
  bodyParams?: CreateCaseBody;
}

export const createCaseHandler = async (args: createCaseArgs, options?: RequestInit) => {
  const res = await createCase(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Probe for candidate cases. Matches the query as a normalized substring of the case id, and fuzzily (trigram) against subject and reporter. Results are relevance-ranked — id matches first, then best fuzzy match, then most recently updated — so ordering is fixed and not configurable.
 * @summary Search cases
 */

export type searchCasesArgs = {
  queryParams: SearchCasesParams;
}

export const searchCasesHandler = async (args: searchCasesArgs, options?: RequestInit) => {
  const res = await searchCases(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a case by id.
 *
 * Related entities are not embedded — fetch them via the filtered list endpoints,
 * e.g. `GET /v1/worker-runs?case_id=…` and `GET /v1/artifacts?metadata[case_id]=…`.
 * @summary Get case
 */

export type getCaseArgs = {
  pathParams: {
    id: string
  };
  queryParams: GetCaseParams;
}

export const getCaseHandler = async (args: getCaseArgs, options?: RequestInit) => {
  const res = await getCase(args.pathParams.id, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Link one or more entities (artifacts, calls, chats, emails, extracts, information requests, schedules, worker runs) to a case.
 *
 * The case and every entity must already exist in the tenant — unknown ids return 404 and nothing is created. Adding is idempotent: re-linking an already linked entity returns the existing link with its original `created_at`.
 * @summary Add case links
 */

export type addCaseLinksArgs = {
  pathParams: {
    id: string
  };
  queryParams: AddCaseLinksParams;
  bodyParams?: AddCaseLinksBody;
}

export const addCaseLinksHandler = async (args: addCaseLinksArgs, options?: RequestInit) => {
  const res = await addCaseLinks(args.pathParams.id, args.bodyParams, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the entities linked to a case, paginated and filterable by entity type.
 * @summary List case links
 */

export type listCaseLinksArgs = {
  pathParams: {
    id: string
  };
  queryParams: ListCaseLinksParams;
}

export const listCaseLinksHandler = async (args: listCaseLinksArgs, options?: RequestInit) => {
  const res = await listCaseLinks(args.pathParams.id, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Remove the link between a case and an entity. Removal is idempotent: removing a link that does not exist succeeds without effect.
 * @summary Remove case link
 */

export type removeCaseLinkArgs = {
  pathParams: {
    id: string,
    entityType: 'artifact' | 'call' | 'chat' | 'email' | 'extract' | 'information_request' | 'schedule' | 'worker_run',
    entityId: string
  };
  queryParams: RemoveCaseLinkParams;
}

export const removeCaseLinkHandler = async (args: removeCaseLinkArgs, options?: RequestInit) => {
  const res = await removeCaseLink(args.pathParams.id, args.pathParams.entityType, args.pathParams.entityId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new chat agent with a name and prompt.
 * @summary Create chat agent
 */

export type createChatAgentArgs = {
  bodyParams?: CreateChatAgentBody;
}

export const createChatAgentHandler = async (args: createChatAgentArgs, options?: RequestInit) => {
  const res = await createChatAgent(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the tenant's chat agents with pagination and sorting. Prompts are not returned.
 * @summary List chat agents
 */

export type listChatAgentsArgs = {
  queryParams: ListChatAgentsParams;
}

export const listChatAgentsHandler = async (args: listChatAgentsArgs, options?: RequestInit) => {
  const res = await listChatAgents(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single chat agent by ID, including the IDs of its attached code tools. The prompt is not returned.
 * @summary Get chat agent
 */

export type getChatAgentArgs = {
  pathParams: {
    chatAgentId: string
  };
}

export const getChatAgentHandler = async (args: getChatAgentArgs, options?: RequestInit) => {
  const res = await getChatAgent(args.pathParams.chatAgentId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Patch a chat agent's settings. Today only the attached code tool set can be edited; future fields will be added under the same endpoint. The response returns the chat agent's metadata only and does not include the resulting tool list; the agent's `updated_at` is not bumped when only the tool set changes.
 * @summary Update chat agent
 */

export type updateChatAgentArgs = {
  pathParams: {
    chatAgentId: string
  };
  bodyParams?: UpdateChatAgentRequest;
}

export const updateChatAgentHandler = async (args: updateChatAgentArgs, options?: RequestInit) => {
  const res = await updateChatAgent(args.pathParams.chatAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Soft-delete a chat agent. The agent no longer appears in any read and stops accepting new chats; existing chats and messages are preserved.
 * @summary Delete chat agent
 */

export type deleteChatAgentArgs = {
  pathParams: {
    chatAgentId: string
  };
}

export const deleteChatAgentHandler = async (args: deleteChatAgentArgs, options?: RequestInit) => {
  const res = await deleteChatAgent(args.pathParams.chatAgentId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve the prompt and greeting for a chat agent. Internal use only.
 * @summary Get chat agent prompt
 */

export type getChatAgentPromptArgs = {
  pathParams: {
    chatAgentId: string
  };
}

export const getChatAgentPromptHandler = async (args: getChatAgentPromptArgs, options?: RequestInit) => {
  const res = await getChatAgentPrompt(args.pathParams.chatAgentId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update the prompt and/or greeting for a chat agent. Internal use only.
 * @summary Update chat agent prompt
 */

export type updateChatAgentPromptArgs = {
  pathParams: {
    chatAgentId: string
  };
  bodyParams?: UpdateChatAgentPromptBody;
}

export const updateChatAgentPromptHandler = async (args: updateChatAgentPromptArgs, options?: RequestInit) => {
  const res = await updateChatAgentPrompt(args.pathParams.chatAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new chat against an existing chat agent. The chat agent's tenant becomes the owner of the chat.
 * @summary Create a chat
 */

export type createChatArgs = {
  bodyParams?: CreateChatBody;
}

export const createChatHandler = async (args: createChatArgs, options?: RequestInit) => {
  const res = await createChat(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Return a chat and its messages in chronological order. Used to re-render a transcript after a reload. Only `user` and `assistant` messages are included; tool calls and tool results are omitted. Each message's `content` is the concatenation of its text blocks separated by newlines.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /public/v1/chat`
 * @summary Get a chat
 */

export type getChatArgs = {
  pathParams: {
    chatId: string
  };
}

export const getChatHandler = async (args: getChatArgs, options?: RequestInit) => {
  const res = await getChat(args.pathParams.chatId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Return the public-facing fields of a chat agent for use in the chat UI. Sensitive fields such as the agent's prompt and tenant ID are not exposed.
 * @summary Get a chat agent (public)
 */

export type getPublicChatAgentArgs = {
  pathParams: {
    chatAgentId: string
  };
}

export const getPublicChatAgentHandler = async (args: getPublicChatAgentArgs, options?: RequestInit) => {
  const res = await getPublicChatAgent(args.pathParams.chatAgentId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Post a user message to an existing chat and return the assistant reply. Both messages are persisted.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /public/v1/chat/messages`
 * @summary Post a message to a chat
 */

export type postChatMessageArgs = {
  pathParams: {
    chatId: string
  };
  bodyParams?: PostChatMessageBody;
}

export const postChatMessageHandler = async (args: postChatMessageArgs, options?: RequestInit) => {
  const res = await postChatMessage(args.pathParams.chatId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the tenant's chats with pagination, sorting, and optional filtering by case. Returns chat metadata and message counts; messages are not included.
 * @summary List chats
 */

export type listChatsArgs = {
  queryParams: ListChatsParams;
}

export const listChatsHandler = async (args: listChatsArgs, options?: RequestInit) => {
  const res = await listChats(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List messages for a chat owned by the tenant, in chronological order by default.
 * @summary List chat messages
 */

export type listChatMessagesArgs = {
  pathParams: {
    chatId: string
  };
  queryParams: ListChatMessagesParams;
}

export const listChatMessagesHandler = async (args: listChatMessagesArgs, options?: RequestInit) => {
  const res = await listChatMessages(args.pathParams.chatId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single extract by ID, including the extraction result data.
 * @summary Get extract
 */

export type getExtractArgs = {
  pathParams: {
    id: string
  };
}

export const getExtractHandler = async (args: getExtractArgs, options?: RequestInit) => {
  const res = await getExtract(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve the citation tree with resolved chunk data for a given extract. Returns 404 if the extract does not exist or has no citations (the citations sub-resource is not available).
 * @summary Get extract citations
 */

export type getExtractCitationsArgs = {
  pathParams: {
    id: string
  };
}

export const getExtractCitationsHandler = async (args: getExtractCitationsArgs, options?: RequestInit) => {
  const res = await getExtractCitations(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all extracts with pagination, filtering, and sorting.
 *
 * **Scope Filtering:**
 *
 * Use bracket notation to filter by scope keys:
 * - `scope[claim_id]=abc-123`
 *
 * Multiple scope filters can be combined (AND logic).
 * @summary List extracts
 */

export type listExtractsArgs = {
  queryParams: ListExtractsParams;
}

export const listExtractsHandler = async (args: listExtractsArgs, options?: RequestInit) => {
  const res = await listExtracts(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve the current user's profile information. This endpoint requires a user session and cannot be used with API Keys.
 * @summary Get profile
 */

export const getProfileHandler = async (options?: RequestInit) => {
  const res = await getProfile(options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all members in the current tenant.
 * @summary List team members
 */

export const listTeamMembersHandler = async (options?: RequestInit) => {
  const res = await listTeamMembers(options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Invite an email address to join the current tenant. The invitee receives an email and joins at the `member` role once they accept; promote them afterwards with `PATCH /v1/team/members/{id}`.
 *
 * Requires the `teams:write` permission.
 *
 * Returns `409` if the address already has a pending invitation or is already a member.
 * @summary Invite a team member
 */

export type inviteTeamMemberArgs = {
  bodyParams?: InviteTeamMemberBody;
}

export const inviteTeamMemberHandler = async (args: inviteTeamMemberArgs, options?: RequestInit) => {
  const res = await inviteTeamMember(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the invitations for the current tenant that are still awaiting acceptance. Accepted, revoked and expired invitations are not returned.
 *
 * Invitees are not team members yet, so they do not appear in `GET /v1/team/members`. A member-management screen shows both by merging the two lists.
 *
 * Requires the `teams:write` permission.
 * @summary List pending team invitations
 */

export const listTeamInvitationsHandler = async (options?: RequestInit) => {
  const res = await listTeamInvitations(options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Cancel a pending invitation. The link that was emailed to the invitee stops working, and the address becomes free to invite again.
 *
 * Idempotent: an invitation that was already accepted, revoked or expired also returns `204`.
 *
 * Requires the `teams:write` permission.
 *
 * Returns `404` for an unknown invitation or one that belongs to another tenant.
 * @summary Revoke a team invitation
 */

export type revokeTeamInvitationArgs = {
  pathParams: {
    invitationId: string
  };
}

export const revokeTeamInvitationHandler = async (args: revokeTeamInvitationArgs, options?: RequestInit) => {
  const res = await revokeTeamInvitation(args.pathParams.invitationId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Email the invitation to its recipient again, for an invite that never arrived. The invitation keeps its `id` and its original expiry — this re-sends the existing link rather than issuing a new one.
 *
 * To give someone a genuinely fresh 5 days, revoke the invitation and send a new one instead.
 *
 * Requires the `teams:write` permission.
 *
 * Returns `409` if the invitation is no longer pending — it was accepted, revoked or expired underneath the caller — and `404` for an unknown invitation or one that belongs to another tenant.
 * @summary Resend a team invitation
 */

export type resendTeamInvitationArgs = {
  pathParams: {
    invitationId: string
  };
}

export const resendTeamInvitationHandler = async (args: resendTeamInvitationArgs, options?: RequestInit) => {
  const res = await resendTeamInvitation(args.pathParams.invitationId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Change the role of a team member.
 * @summary Update member role
 */

export type updateMemberRoleArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: UpdateMemberRoleBody;
}

export const updateMemberRoleHandler = async (args: updateMemberRoleArgs, options?: RequestInit) => {
  const res = await updateMemberRole(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Soft-delete a team member, revoking access on the next token refresh.
 * @summary Remove team member
 */

export type removeMemberArgs = {
  pathParams: {
    id: string
  };
}

export const removeMemberHandler = async (args: removeMemberArgs, options?: RequestInit) => {
  const res = await removeMember(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create an organization-level secret. The value is encrypted at rest and **write-only** — no endpoint ever returns it.
 *
 * Requires the `secrets:write` permission. Env keys used by the worker runtime itself (e.g. `OPENAI_API_KEY`, `AVALLON_*`, `AWS_*`) are reserved and rejected.
 * @summary Create a secret
 */

export type createSecretArgs = {
  bodyParams?: CreateSecretBody;
}

export const createSecretHandler = async (args: createSecretArgs, options?: RequestInit) => {
  const res = await createSecret(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the organization's secrets with pagination and sorting. Values are never included. Requires the `secrets:read` permission.
 * @summary List secrets
 */

export type listSecretsArgs = {
  queryParams: ListSecretsParams;
}

export const listSecretsHandler = async (args: listSecretsArgs, options?: RequestInit) => {
  const res = await listSecrets(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Get a secret's metadata. The value is never included. Requires the `secrets:read` permission.
 * @summary Get secret
 */

export type getSecretArgs = {
  pathParams: {
    secretId: string
  };
}

export const getSecretHandler = async (args: getSecretArgs, options?: RequestInit) => {
  const res = await getSecret(args.pathParams.secretId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update a secret's display name or description, or rotate its live or test value. Rotation overwrites the stored value — previous values are not retrievable.
 *
 * The `env_key` is immutable: consumers of the secret receive the value under that key, so changing it would silently break them. Create a new secret instead.
 *
 * Requires the `secrets:write` permission.
 * @summary Update secret
 */

export type updateSecretArgs = {
  pathParams: {
    secretId: string
  };
  bodyParams?: UpdateSecretBody;
}

export const updateSecretHandler = async (args: updateSecretArgs, options?: RequestInit) => {
  const res = await updateSecret(args.pathParams.secretId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Delete a secret and detach it from all entities. Requires the `secrets:write` permission.
 * @summary Delete secret
 */

export type deleteSecretArgs = {
  pathParams: {
    secretId: string
  };
}

export const deleteSecretHandler = async (args: deleteSecretArgs, options?: RequestInit) => {
  const res = await deleteSecret(args.pathParams.secretId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a schedule that performs an action, either repeatedly or once.
 *
 * `action` describes **what** happens — today only `trigger_worker`, which starts a worker run with the given scope. `rule` describes **when**: `recurring` carries one or more `patterns`, and fires whenever any of them comes round. A pattern fires every hour at `minute`, narrowed by `hours` and `weekdays` — so `hours: [9]` is daily at 09:00, `hours: [12], weekdays: [1]` is Mondays at noon, and `hours: [9, 13, 17], weekdays: [1, 2, 3, 4, 5]` is three times a day on weekdays. Give a second pattern to mix cadences: hourly on weekdays plus 09:00, 11:00 and 18:00 at weekends is two patterns on one schedule. Patterns overlap harmlessly — two that land on the same minute fire once. Every set is read in the schedule's own time zone — an IANA identifier such as `America/Chicago`, resolved across DST transitions. `once` fires a single time at a UTC instant.
 *
 * `environments` says **which worker version** each occurrence runs: `live` resolves the worker at its live version, `test` at its test version. Give both to soak a candidate version on the same cadence and scope as production — every occurrence then fires twice, producing one run per environment. Omit it to fire in `live` only.
 *
 * The response's `next_run_at` is the first occurrence strictly after the moment of creation; a rule that resolves to no such occurrence is rejected. Create with `enabled: false` to stage a recurring schedule without letting it fire. A one-off is always enabled: delete it to cancel it, and its `next_run_at` becomes null once it has fired.
 *
 * Requires the `schedules:write` permission.
 * @summary Create a schedule
 */

export type createScheduleArgs = {
  bodyParams?: CreateScheduleBody;
}

export const createScheduleHandler = async (args: createScheduleArgs, options?: RequestInit) => {
  const res = await createSchedule(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the organization's schedules. Requires the `schedules:read` permission.
 * @summary List schedules
 */

export type listSchedulesArgs = {
  queryParams: ListSchedulesParams;
}

export const listSchedulesHandler = async (args: listSchedulesArgs, options?: RequestInit) => {
  const res = await listSchedules(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single schedule. Requires the `schedules:read` permission.
 * @summary Get a schedule
 */

export type getScheduleArgs = {
  pathParams: {
    scheduleId: string
  };
}

export const getScheduleHandler = async (args: getScheduleArgs, options?: RequestInit) => {
  const res = await getSchedule(args.pathParams.scheduleId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update a schedule's rule, environments, name, or enabled state.
 *
 * Changing the rule moves `next_run_at` to the first occurrence after the update; a rule that resolves to no such occurrence is rejected. One-off schedules are always enabled — delete one to cancel it before it fires.
 *
 * `environments` replaces the whole list rather than adding to it. It takes effect from the next occurrence: one already due keeps the environments it was created with.
 * @summary Update a schedule
 */

export type updateScheduleArgs = {
  pathParams: {
    scheduleId: string
  };
  bodyParams?: UpdateScheduleBody;
}

export const updateScheduleHandler = async (args: updateScheduleArgs, options?: RequestInit) => {
  const res = await updateSchedule(args.pathParams.scheduleId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Delete a schedule so it stops firing.
 * @summary Delete a schedule
 */

export type deleteScheduleArgs = {
  pathParams: {
    scheduleId: string
  };
}

export const deleteScheduleHandler = async (args: deleteScheduleArgs, options?: RequestInit) => {
  const res = await deleteSchedule(args.pathParams.scheduleId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the organization's dispatches, newest occurrence first.
 *
 * A dispatch is one occurrence of a trigger in one environment, carried out on its own: a schedule produces one per environment it runs in every time it fires, an inbound email produces one for the environment its inbox received it in, and a resolved information request produces one that restarts the worker that asked. Listing them shows what a trigger has actually done, including occurrences that never produced anything.
 *
 * - `pending` — not carried out yet: waiting to be picked up, in flight, or waiting on a retry after an earlier pickup did not complete.
 * - `dispatched` — carried out.
 * - `abandoned` — gave up, because the occurrence passed its `expires_at` deadline before it could be carried out.
 *
 * `attempts` counts how many times the occurrence has been picked up, not how many times it failed: a dispatch carried out on the first pickup ends at `attempts: 1`, and a higher count means earlier pickups did not complete.
 *
 * `target` is what the occurrence produced — a worker run, or an extractor job for an email whose inbox extracts. It is null until the dispatch is carried out, and stays null on one that was abandoned.
 *
 * Narrow to one trigger with `trigger_type` and `trigger_id` — the schedule's ID for a schedule, the email's ID for an email, the request's ID for an information request. `trigger_id` requires `trigger_type`.
 * @summary List dispatches
 */

export type listDispatchesArgs = {
  queryParams: ListDispatchesParams;
}

export const listDispatchesHandler = async (args: listDispatchesArgs, options?: RequestInit) => {
  const res = await listDispatches(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the organization's notifications, newest first.
 *
 * A notification is a durable record that something happened and that somebody should know about it. Notifications are not yet addressed to individual people, so everyone in the organization sees the same feed.
 *
 * `title` and `body` are the display text — render them as-is rather than deriving your own wording from `type`, so every surface says the same thing. `data` carries the identifiers the notification points at, so a client can link to the thing it is about; which keys are present depends on `type`.
 *
 * `worker_issue_reported` means a worker hit a problem during a run and reported it; its `body` is the worker's own message and its `data` is the reporting `worker_id` and `run_id`. `information_request_created` means a worker paused to ask a person a question; its `data` is the `request_id` to answer through `POST /v1/information-requests/{informationRequestId}/resolve`.
 * @summary List notifications
 */

export type listNotificationsArgs = {
  queryParams: ListNotificationsParams;
}

export const listNotificationsHandler = async (args: listNotificationsArgs, options?: RequestInit) => {
  const res = await listNotifications(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Ask a person for a specific fact you cannot establish yourself.
 *
 * Use this when one missing piece of information is blocking you and only a human can supply it — which claim a document belongs to, which of two policies applies, what an ambiguous reference means. Ask one answerable question per request, and write it so it stands on its own: whoever resolves it sees your title and your question and nothing else.
 *
 * Immediately link the request to its case with `addCaseLinks` and `entity_type: "information_request"`. That is how it reaches the person working that case; unlinked, it sits in a queue nobody is looking at. Leave it unlinked only when you genuinely cannot tell which case it belongs to.
 *
 * **This does not block or suspend you.** Nobody resolves it while this run is happening. Carry on with what you can still do, or stop, and say in your final report that you asked.
 *
 * Do not use it for progress updates, or for anything you can work out yourself.
 * @summary Ask for information
 */

export type createInformationRequestArgs = {
  bodyParams?: CreateInformationRequestBody;
}

export const createInformationRequestHandler = async (args: createInformationRequestArgs, options?: RequestInit) => {
  const res = await createInformationRequest(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the organization's information requests, newest first.
 *
 * An information request is a specific question a worker could not settle on its own and needs a person to resolve. It stays open until somebody resolves it; there is no separate status field.
 * @summary List information requests
 */

export type listInformationRequestsArgs = {
  queryParams: ListInformationRequestsParams;
}

export const listInformationRequestsHandler = async (args: listInformationRequestsArgs, options?: RequestInit) => {
  const res = await listInformationRequests(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single information request by its ID.
 * @summary Get information request
 */

export type getInformationRequestArgs = {
  pathParams: {
    informationRequestId: string
  };
}

export const getInformationRequestHandler = async (args: getInformationRequestArgs, options?: RequestInit) => {
  const res = await getInformationRequest(args.pathParams.informationRequestId, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Resolve an open information request by providing an answer/resolution.
 * @summary Resolve information request
 */

export type resolveInformationRequestArgs = {
  pathParams: {
    informationRequestId: string
  };
  bodyParams?: ResolveInformationRequestBody;
}

export const resolveInformationRequestHandler = async (args: resolveInformationRequestArgs, options?: RequestInit) => {
  const res = await resolveInformationRequest(args.pathParams.informationRequestId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a new code tool that can be attached to agents. Provide the tool's name, code, and description.
 * @summary Create tool
 */

export type createToolArgs = {
  bodyParams?: CreateToolBody;
}

export const createToolHandler = async (args: createToolArgs, options?: RequestInit) => {
  const res = await createTool(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all code tools with sorting.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /worker/v1/tools`
 * @summary List tools
 */

export type listToolsArgs = {
  queryParams: ListToolsParams;
}

export const listToolsHandler = async (args: listToolsArgs, options?: RequestInit) => {
  const res = await listTools(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Delete a tool. Fails with a conflict when the tool is still attached to a voice agent, worker, or chat agent; detach it first.
 * @summary Delete tool
 */

export type deleteToolArgs = {
  pathParams: {
    id: string
  };
}

export const deleteToolHandler = async (args: deleteToolArgs, options?: RequestInit) => {
  const res = await deleteTool(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single tool by ID at its newest config version, including its code, schema, description and attached secrets, plus the versions each environment runs.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /worker/v1/tools/{id}`
 * @summary Get tool
 */

export type getToolArgs = {
  pathParams: {
    id: string
  };
}

export const getToolHandler = async (args: getToolArgs, options?: RequestInit) => {
  const res = await getTool(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update a code tool's name, description, code, or attached secrets. All fields are optional — only provided fields are updated.
 *
 * Changing the code, description or attached secrets creates a new config version; runs keep executing the versions promoted to live and test until that version is promoted. Renaming does not create a version.
 * @summary Update tool
 */

export type updateToolArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: UpdateToolBody;
}

export const updateToolHandler = async (args: updateToolArgs, options?: RequestInit) => {
  const res = await updateTool(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Execute a code tool with the given parameters. Returns the result, any errors, and execution traces.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /worker/v1/tools/{id}/execute`
 * @summary Execute tool
 */

export type executeCodeArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: ExecuteCodeBody;
}

export const executeCodeHandler = async (args: executeCodeArgs, options?: RequestInit) => {
  const res = await executeCode(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all config versions for a tool, ordered by version (newest first by default).
 * @summary List tool versions
 */

export type listToolVersionsArgs = {
  pathParams: {
    id: string
  };
  queryParams: ListToolVersionsParams;
}

export const listToolVersionsHandler = async (args: listToolVersionsArgs, options?: RequestInit) => {
  const res = await listToolVersions(args.pathParams.id, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single tool config version: the tool's identity, the code, schema, description and attached secrets at that version, and version metadata.
 * @summary Get tool version
 */

export type getToolVersionArgs = {
  pathParams: {
    id: string,
    version: number
  };
}

export const getToolVersionHandler = async (args: getToolVersionArgs, options?: RequestInit) => {
  const res = await getToolVersion(args.pathParams.id, args.pathParams.version, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Select a tool config version for the live or test environment. Runs in that environment execute this version's code with this version's schema and attached secrets from then on.
 * @summary Promote tool version
 */

export type promoteToolVersionArgs = {
  pathParams: {
    id: string,
    version: number
  };
  bodyParams?: PromoteToolVersionBody;
}

export const promoteToolVersionHandler = async (args: promoteToolVersionArgs, options?: RequestInit) => {
  const res = await promoteToolVersion(args.pathParams.id, args.pathParams.version, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.
 * @summary Get tool version change summary
 */

export type getToolVersionChangeSummaryArgs = {
  pathParams: {
    id: string,
    version: number
  };
}

export const getToolVersionChangeSummaryHandler = async (args: getToolVersionChangeSummaryArgs, options?: RequestInit) => {
  const res = await getToolVersionChangeSummary(args.pathParams.id, args.pathParams.version, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all code tools with sorting.
 * @deprecated
 * @summary List tools
 */

export type workerListToolsArgs = {
  queryParams: WorkerListToolsParams;
}

export const workerListToolsHandler = async (args: workerListToolsArgs, options?: RequestInit) => {
  const res = await workerListTools(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single tool by ID at its newest config version, including its code, schema, description and attached secrets, plus the versions each environment runs.
 * @deprecated
 * @summary Get tool
 */

export type workerGetToolArgs = {
  pathParams: {
    id: string
  };
}

export const workerGetToolHandler = async (args: workerGetToolArgs, options?: RequestInit) => {
  const res = await workerGetTool(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Execute a code tool with the given parameters. Returns the result, any errors, and execution traces.
 * @deprecated
 * @summary Execute tool
 */

export type workerExecuteToolArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: WorkerExecuteToolBody;
}

export const workerExecuteToolHandler = async (args: workerExecuteToolArgs, options?: RequestInit) => {
  const res = await workerExecuteTool(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Report a problem to the people who run this organization.
 *
 * Use this for something a human has to resolve — a login that no longer works, a document you cannot read, a system that will not let you in, instructions that contradict what you found. The report goes to the organization's notifications; nobody sees it while the run is happening, so it does not unblock you now. Carry on with what you can still do, or stop, and say in your final report that you raised it.
 *
 * Do not use it for progress updates or for anything you can work around yourself.
 * @summary Notify an admin
 */

export type notifyAdminArgs = {
  bodyParams?: NotifyAdminBody;
}

export const notifyAdminHandler = async (args: notifyAdminArgs, options?: RequestInit) => {
  const res = await notifyAdmin(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Upload a file for processing by passing a URL to a file. Use this for uploading larger files.
 *
 * This endpoint returns an upload id that can be used to find the created artifacts using the list artifacts endpoint.
 * @summary Upload a file for processing
 */

export type uploadFileArgs = {
  bodyParams?: UploadFileBody;
}

export const uploadFileHandler = async (args: uploadFileArgs, options?: RequestInit) => {
  const res = await uploadFile(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a webhook that fires when events occur for the specified voice agent.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents/{id}/webhooks`
 * @summary Create voice agent webhook
 */

export type createAgentWebhookArgs = {
  pathParams: {
    voiceAgentId: string
  };
  bodyParams?: CreateAgentWebhookBody;
}

export const createAgentWebhookHandler = async (args: createAgentWebhookArgs, options?: RequestInit) => {
  const res = await createAgentWebhook(args.pathParams.voiceAgentId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all webhooks configured for a specific voice agent.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/{id}/webhooks`
 * @summary List voice agent webhooks
 */

export type listAgentWebhooksArgs = {
  pathParams: {
    voiceAgentId: string
  };
  queryParams: ListAgentWebhooksParams;
}

export const listAgentWebhooksHandler = async (args: listAgentWebhooksArgs, options?: RequestInit) => {
  const res = await listAgentWebhooks(args.pathParams.voiceAgentId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a webhook that fires when events occur for the specified inbox.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/email-agents/{id}/webhooks`
 * @summary Create inbox webhook
 */

export type createInboxWebhookArgs = {
  pathParams: {
    inboxId: string
  };
  bodyParams?: CreateInboxWebhookBody;
}

export const createInboxWebhookHandler = async (args: createInboxWebhookArgs, options?: RequestInit) => {
  const res = await createInboxWebhook(args.pathParams.inboxId, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all webhooks configured for a specific inbox.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/email-agents/{id}/webhooks`
 * @summary List inbox webhooks
 */

export type listInboxWebhooksArgs = {
  pathParams: {
    inboxId: string
  };
  queryParams: ListInboxWebhooksParams;
}

export const listInboxWebhooksHandler = async (args: listInboxWebhooksArgs, options?: RequestInit) => {
  const res = await listInboxWebhooks(args.pathParams.inboxId, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a webhook that fires when extraction events occur for the specified extractor.
 * @summary Create extractor webhook
 */

export type createExtractorWebhookArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: CreateExtractorWebhookBody;
}

export const createExtractorWebhookHandler = async (args: createExtractorWebhookArgs, options?: RequestInit) => {
  const res = await createExtractorWebhook(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List all webhooks configured for a specific extractor.
 * @summary List extractor webhooks
 */

export type listWebhooksArgs = {
  pathParams: {
    id: string
  };
  queryParams: ListWebhooksParams;
}

export const listWebhooksHandler = async (args: listWebhooksArgs, options?: RequestInit) => {
  const res = await listWebhooks(args.pathParams.id, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Create a webhook that fires whenever a notification is raised for the organization.
 *
 * Notifications belong to the organization rather than to a resource, so this webhook is not attached to anything: its `scope` is `{ "notifications": true }` and it receives every notification the organization raises. Each delivery carries the notification's `title` and `body` — the same display text `GET /v1/notifications` returns — alongside the structured `data` it points at.
 *
 * Notifications are not environment-specific, so every delivery is `live`. A webhook that names only `test` receives nothing.
 * @summary Create notification webhook
 */

export type createNotificationWebhookArgs = {
  bodyParams?: CreateNotificationWebhookBody;
}

export const createNotificationWebhookHandler = async (args: createNotificationWebhookArgs, options?: RequestInit) => {
  const res = await createNotificationWebhook(args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List the webhooks that receive the organization's notifications.
 * @summary List notification webhooks
 */

export type listNotificationWebhooksArgs = {
  queryParams: ListNotificationWebhooksParams;
}

export const listNotificationWebhooksHandler = async (args: listNotificationWebhooksArgs, options?: RequestInit) => {
  const res = await listNotificationWebhooks(args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Permanently delete a webhook. This action is irreversible.
 * @summary Delete webhook
 */

export type deleteWebhookArgs = {
  pathParams: {
    id: string
  };
}

export const deleteWebhookHandler = async (args: deleteWebhookArgs, options?: RequestInit) => {
  const res = await deleteWebhook(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Retrieve a single webhook by ID. The authentication header value is never exposed — only `has_auth` indicates whether authentication is configured.
 * @summary Get webhook
 */

export type getWebhookArgs = {
  pathParams: {
    id: string
  };
}

export const getWebhookHandler = async (args: getWebhookArgs, options?: RequestInit) => {
  const res = await getWebhook(args.pathParams.id, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Update a webhook's name, destination, environments, enabled state, or authentication. Omitted fields are left unchanged, and at least one must be provided.
 * @summary Update webhook
 */

export type updateWebhookArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: UpdateWebhookBody;
}

export const updateWebhookHandler = async (args: updateWebhookArgs, options?: RequestInit) => {
  const res = await updateWebhook(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * List delivery attempts for a specific webhook, with pagination and sorting. Useful for debugging webhook issues.
 * @summary List webhook deliveries
 */

export type listWebhookDeliveriesArgs = {
  pathParams: {
    id: string
  };
  queryParams: ListWebhookDeliveriesParams;
}

export const listWebhookDeliveriesHandler = async (args: listWebhookDeliveriesArgs, options?: RequestInit) => {
  const res = await listWebhookDeliveries(args.pathParams.id, args.queryParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};

/**
 * Send a test event to a webhook endpoint. Returns the HTTP status code, response time, and any errors. The request is rejected with a 400 if the webhook does not target the given environment, since a successful ping would say nothing about events it will never receive.
 * @summary Test webhook
 */

export type testWebhookArgs = {
  pathParams: {
    id: string
  };
  bodyParams?: TestWebhookBody;
}

export const testWebhookHandler = async (args: testWebhookArgs, options?: RequestInit) => {
  const res = await testWebhook(args.pathParams.id, args.bodyParams, options);

  if (res.status >= 400) {
    return {
      content: [
        {
          type: 'text' as const,
          text: JSON.stringify(res.data ?? null),
        },
      ],
      isError: true,
    };
  }

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res.data ?? null),
      },
    ],
    structuredContent: res.data,
  };
};
